import React, { createContext, useState, useContext } from 'react';

// Création du contexte pour les modales
const ModalContext = createContext();

// Hook personnalisé pour utiliser le contexte
export const useModalContext = () => useContext(ModalContext);

// Fournisseur du contexte
export const ModalProvider = ({ children }) => {
  // État pour stocker la position du clic
  const [clickPosition, setClickPosition] = useState({ x: 0, y: 0 });

  // Fonction pour mettre à jour la position du clic (robuste à plusieurs signatures)
  // Accepte :
  //  - updateClickPosition(event)
  //  - updateClickPosition({ x, y })
  //  - updateClickPosition(x, y)
  const updateClickPosition = (...args) => {
    if (!args || args.length === 0) return;
    let x = 0;
    let y = 0;

    const first = args[0];
    const second = args[1];

    // Cas 1: event natif avec clientX/clientY
    if (first && typeof first === 'object' && typeof first.clientX === 'number' && typeof first.clientY === 'number') {
      x = first.clientX;
      y = first.clientY;
    }
    // Cas 2: objet { x, y }
    else if (first && typeof first === 'object' && typeof first.x === 'number' && typeof first.y === 'number') {
      x = first.x;
      y = first.y;
    }
    // Cas 3: deux nombres (x, y)
    else if (typeof first === 'number' && typeof second === 'number') {
      x = first;
      y = second;
    } else {
      // Signature inconnue, ne rien faire
      return;
    }

    setClickPosition({ x, y });
  };

  // Valeur du contexte
  const value = {
    clickPosition,
    updateClickPosition
  };

  return (
    <ModalContext.Provider value={value}>
      {children}
    </ModalContext.Provider>
  );
};

export default ModalContext;